<div class="d-flex justify-content-between flex-column">
  <ng-container *ngIf="!init; else showContent">
    <mat-spinner
      class="init-spinner"
      color="primary"
      diameter="75"
    ></mat-spinner>
  </ng-container>
  <ng-template #showContent>
    <ng-container
      *ngTemplateOutlet="
        employeeTourSelector;
        context: { selectorObject: firstSelectorObject }
      "
    >
    </ng-container>
    <hr class="w-75" />
    <ng-container
      *ngTemplateOutlet="
        employeeTourSelector;
        context: { selectorObject: secondSelectorObject }
      "
    >
    </ng-container>
  </ng-template>
</div>
<div class="button-container">
  <ng-container *ngIf="!loading">
    <button mat-button (click)="closeDialog()">
      Sluiten
    </button>
    <button mat-button class="confirm-button" (click)="loadPreviews()">
      Selecteer previews
    </button>
  </ng-container>
  <ng-container *ngIf="loading">
    <mat-spinner color="primary" diameter="48"></mat-spinner>
  </ng-container>
</div>

<ng-template #employeeTourSelector let-selectorObject="selectorObject">
  <div>
    <div class="employee-selector">
      <mat-form-field appearance="outline">
        <mat-select
          matInput
          placeholder="Kies een installateur"
          [(ngModel)]="selectorObject.placer"
          name="placer"
          [compareWith]="compareEntities"
        >
          <mat-option *ngFor="let option of placers" [value]="option">
            <span>{{
              option.user?.firstName | personName: option.user?.lastName
            }}</span>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="upper-space d-flex justify-content-center">
      <mat-form-field appearance="outline">
        <input
          matInput
          [min]="today"
          [matDatepicker]="firstTourDatePicker"
          placeholder="Selecteer een datum"
          [(ngModel)]="selectorObject.date1"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="firstTourDatePicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #firstTourDatePicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline" class="small-left-space">
        <input
          matInput
          [min]="today"
          [matDatepicker]="secondTourDatePicker"
          placeholder="Selecteer een datum"
          [(ngModel)]="selectorObject.date2"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="secondTourDatePicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #secondTourDatePicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline" class="small-left-space">
        <input
          matInput
          [min]="today"
          [matDatepicker]="thirdTourDatePicker"
          placeholder="Selecteer een datum"
          [(ngModel)]="selectorObject.date3"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="thirdTourDatePicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #thirdTourDatePicker></mat-datepicker>
      </mat-form-field>
    </div>
  </div>
</ng-template>
